import React from 'react'
import bg15 from '../../assets/images/background/bg-15.png'
import siconone from '../../assets/images/resource/s-icon-1.png'
import sicontwo from '../../assets/images/resource/s-icon-2.png'
import siconthree from '../../assets/images/resource/s-icon-3.png'
import siconfour from '../../assets/images/resource/s-icon-4.png'
import service from '../../assets/images/resource/service-image-png.jpg'


function Aboutservice() {
    return (
        <>
            <section className="services-section">
                <div className="right-bg"><img src={bg15} alt="" title="" /></div>
                <div className="auto-container">
                    <div className="title-box centered">
                        <div className="subtitle"><span>naše usluge</span></div>

                        <div className="pattern-image">
                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                        </div>

                        <h2>Vaša omiljena picerija u Smederevu</h2>
                    </div>
                    <div className="row clearfix">
                        <div className="s-col col-lg-4 col-md-6 col-sm-12">
                            <div className="inner wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="s-block">
                                    <div className="inner">
                                        <div className="icon-box"><img src={siconone} alt="" title="" /></div>
                                        <h4>Brza Dostava</h4>
                                        <div className="text">Dostavljamo vam omiljenu hranu na kućnu adresu. Topla, sveža i uvek na vreme!</div>
                                    </div>
                                </div>
                                <div className="s-block alternate">
                                    <div className="inner">
                                        <div className="icon-box"><img src={sicontwo} alt="" title="" /></div>
                                        <h4>Preuzimanje u Lokalu</h4>
                                        <div className="text">Poručite unapred i preuzmite svoju porudžbinu spremnu za vas. Brzo i praktično!</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="s-col last col-lg-4 col-md-6 col-sm-12">
                            <div className="inner wow fadeInRight" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="s-block alternate">
                                    <div className="inner">
                                        <div className="icon-box"><img src={siconthree} alt="" title="" /></div>
                                        <h4>Naručivanje Putem Aplikacija</h4>
                                        <div className="text">Naručite lako i brzo preko Glovo i Wolt aplikacija. Pratite svoju porudžbinu u realnom vremenu!</div>
                                    </div>
                                </div>
                                <div className="s-block">
                                    <div className="inner">
                                        <div className="icon-box"><img src={siconfour} alt="" title="" /></div>
                                         <h4>Raznovrsna Ponuda</h4>
                                         <div className="text">Pice, tortilje, palačinke, sendviči i još mnogo toga. Više od 30 različitih jela za svaki ukus!</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="image-col col-lg-4 col-md-12 col-sm-12">
                            <div className="inner wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="0ms">
                                <div className="image-box"><img src={service} alt="" title="" /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Aboutservice